(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6VBea", function(module, exports) {
$parcel$export(module.exports, "b64_decode", function () { return (parcelRequire("hDdJN")).b64_decode; });
$parcel$export(module.exports, "getAllCookies", function () { return (parcelRequire("fnNvV")).getAllCookies; });
$parcel$export(module.exports, "elementReady", function () { return (parcelRequire("7YAJ4")).elementReady; });
$parcel$export(module.exports, "addWindowResizeEvent", function () { return (parcelRequire("2pyvk")).addWindowResizeEvent; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return (parcelRequire("2pyvk")).addWindowScrollEvent; });
$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return (parcelRequire("9uiPq")).getReCAPTCHAResponse; });
$parcel$export(module.exports, "slideDown", function () { return (parcelRequire("cPDzI")).slideDown; });
$parcel$export(module.exports, "slideUp", function () { return (parcelRequire("cPDzI")).slideUp; });
$parcel$export(module.exports, "scrollToElement", function () { return (parcelRequire("9vUSI")).scrollToElement; });
$parcel$export(module.exports, "getThemeData", function () { return (parcelRequire("4XCT3")).getThemeData; });
$parcel$export(module.exports, "waitForElement", function () { return (parcelRequire("5BaYK")).waitForElement; });
parcelRequire("hDdJN");
parcelRequire("fnNvV");
parcelRequire("7YAJ4");
parcelRequire("2pyvk");
parcelRequire("9uiPq");
parcelRequire("cPDzI");
parcelRequire("9vUSI");
parcelRequire("4XCT3");
parcelRequire("5BaYK");

});
parcelRegister("hDdJN", function(module, exports) {

$parcel$export(module.exports, "b64_decode", function () { return $cd60bc3867d72b58$export$bf9d481ba07b53f9; });
var $cd60bc3867d72b58$export$3c2a198a9c1ae5f3 = function(string) {
    return window.btoa(unescape(encodeURIComponent(string)));
};
var $cd60bc3867d72b58$export$bf9d481ba07b53f9 = function(string) {
    return decodeURIComponent(escape(window.atob(string)));
};

});

parcelRegister("fnNvV", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", function () { return $b32f6972fc6e67b5$export$1191989ae3ee4c15; });
var $b32f6972fc6e67b5$export$1191989ae3ee4c15 = function() {
    var cookies = document.cookie.split('; ');
    var allCookies = [];
    cookies.forEach(function(cookie) {
        var cookieParts = cookie.split('=');
        allCookies[cookieParts[0]] = cookieParts[1];
    });
    return allCookies;
};

});

parcelRegister("7YAJ4", function(module, exports) {

$parcel$export(module.exports, "elementReady", function () { return $5cea9fff8806cfad$export$5a68694636710d38; });
var $5cea9fff8806cfad$export$5a68694636710d38 = function(selector) {
    return new Promise(function(resolve) {
        var el = document.querySelectorAll(selector);
        if (el.length) {
            resolve(el);
            return;
        }
        new MutationObserver(function() {
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach(function(element) {
                resolve(element);
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });
};

});

parcelRegister("2pyvk", function(module, exports) {

$parcel$export(module.exports, "addWindowResizeEvent", function () { return $1c18ae62fb4dbf93$export$5f2cd73bfe4df536; });
$parcel$export(module.exports, "addWindowScrollEvent", function () { return $1c18ae62fb4dbf93$export$b502183889628ce0; });
var $1c18ae62fb4dbf93$export$5f2cd73bfe4df536 = function(callback) {
    var timeout;
    window.addEventListener('resize', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};
var $1c18ae62fb4dbf93$export$b502183889628ce0 = function(callback) {
    var timeout;
    window.addEventListener('scroll', function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};

});

parcelRegister("9uiPq", function(module, exports) {

$parcel$export(module.exports, "getReCAPTCHAResponse", function () { return $6e85854efd3089cd$export$26ae508a4c7ca84d; });

var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");

var $4XCT3 = parcelRequire("4XCT3");
var $6e85854efd3089cd$export$26ae508a4c7ca84d = function(action) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var _themeData_ajax_actions, themeData, e;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $4XCT3.getThemeData)()
                    ];
                case 1:
                    themeData = _state.sent();
                    if (!themeData.recaptcha_site_key) throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
                    if (!((_themeData_ajax_actions = themeData.ajax_actions) === null || _themeData_ajax_actions === void 0 ? void 0 : _themeData_ajax_actions.recaptcha_verify)) throw new Error('Missing AJAX route to verify reCAPTCHA token');
                    if (!themeData.ajax_route) throw new Error('Missing global AJAX route');
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            if (window.grecaptcha === undefined) {
                                console.warn('Google reCAPTCHA is not loaded');
                                resolve({
                                    success: true,
                                    score: 1
                                });
                            } else window.grecaptcha.ready(function() {
                                window.grecaptcha.execute(themeData.recaptcha_site_key, {
                                    action: action
                                }).then(function(token) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                                        var formData, testParam, url, response, json, errorMessages, e;
                                        return (0, $gh3Df._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    formData = new FormData();
                                                    formData.append('action', themeData.ajax_actions.recaptcha_verify);
                                                    // Determine if request is just a test
                                                    testParam = 'e2e-test';
                                                    url = new URL(window.location);
                                                    if (url.searchParams.has(testParam)) token = 'e2e-test-valid-user';
                                                    // Set reCAPTCHA token
                                                    formData.append('recaptcha_token', token);
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        4,
                                                        ,
                                                        5
                                                    ]);
                                                    return [
                                                        4,
                                                        fetch(themeData.ajax_route, {
                                                            method: 'POST',
                                                            body: formData
                                                        })
                                                    ];
                                                case 2:
                                                    response = _state.sent();
                                                    return [
                                                        4,
                                                        response.json()
                                                    ];
                                                case 3:
                                                    json = _state.sent();
                                                    if (json.success) resolve(json);
                                                    else if (json['error-codes']) {
                                                        /**
								 * reCAPTCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */ errorMessages = [];
                                                        json['error-codes'].forEach(function(errorCode) {
                                                            switch(errorCode){
                                                                case 'missing-input-secret':
                                                                    errorMessages.push('The secret parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-secret':
                                                                    errorMessages.push('The secret parameter is invalid or malformed.');
                                                                    break;
                                                                case 'missing-input-response':
                                                                    errorMessages.push('The response parameter is missing.');
                                                                    break;
                                                                case 'invalid-input-response':
                                                                    errorMessages.push('The response parameter is invalid or malformed.');
                                                                    break;
                                                                case 'bad-request':
                                                                    errorMessages.push('The request is invalid or malformed.');
                                                                    break;
                                                                case 'timeout-or-duplicate':
                                                                    errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
                                                                    break;
                                                                default:
                                                                    errorMessages.push('Unknown reCAPTCHA error code');
                                                            }
                                                        });
                                                        throw new Error("There was an error when trying to verify the user's response by reCAPTCHA:\n".concat(errorMessages.join('\n')));
                                                    } else if (json.data) throw new Error("The request to verify the reCAPTCHA user token failed: ".concat(response.data));
                                                    else throw new Error('Unknown error occurred when trying to verify the reCAPTCHA user token');
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 4:
                                                    e = _state.sent();
                                                    reject(e);
                                                    return [
                                                        3,
                                                        5
                                                    ];
                                                case 5:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                            });
                        })
                    ];
                case 2:
                    e = _state.sent();
                    console.error(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};

});
parcelRegister("dxEC4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dbddc5847e39269$export$71511d61b312f219; });
function $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dbddc5847e39269$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("gh3Df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd910d1ee9896911$export$71511d61b312f219; });
function $bd910d1ee9896911$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("4XCT3", function(module, exports) {

$parcel$export(module.exports, "getThemeData", function () { return $39cad640efa60b84$export$3c72f11fd9e5031f; });
var $39cad640efa60b84$export$3c72f11fd9e5031f = function() {
    if (!window.themeDataRestUrl) throw new Error('Missing themeDataRestUrl in global context');
    else {
        var sessionStorageKey = 'themeData';
        return new Promise(function(resolve, reject) {
            if (sessionStorage.getItem('themeData')) resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
            else fetch(window.themeDataRestUrl).then(function(res) {
                return res.json();
            }).then(function(data) {
                try {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
                } catch (e) {
                    console.warn(e);
                }
                resolve(data);
            }).catch(function(e) {
                return reject(e);
            });
        });
    }
};

});


parcelRegister("cPDzI", function(module, exports) {

$parcel$export(module.exports, "slideUp", function () { return $9578f243206a91ae$export$deed561b1a0ff1ea; });
$parcel$export(module.exports, "slideDown", function () { return $9578f243206a91ae$export$abdd11a06a163232; });
var $9578f243206a91ae$export$deed561b1a0ff1ea = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        window.setTimeout(function() {
            if (!isSearchable) target.style.display = 'none';
            [
                'height',
                'padding-top',
                'padding-bottom',
                'margin-top',
                'margin-bottom',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$abdd11a06a163232 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, isSearchable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return new Promise(function(resolve) {
        if (!isSearchable) {
            target.style.removeProperty('display');
            var display = window.getComputedStyle(target).display;
            if (display === 'none') display = 'block';
            target.style.display = display;
        }
        var height = target.offsetHeight;
        target.style.overflow = 'hidden';
        [
            'height',
            'paddingTop',
            'paddingBottom',
            'marginTop',
            'marginBottom'
        ].forEach(function(prop) {
            target.style[prop] = 0;
        });
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        [
            'padding-top',
            'padding-bottom',
            'margin-top',
            'margin-bottom'
        ].forEach(function(prop) {
            return target.style.removeProperty(prop);
        });
        window.setTimeout(function() {
            [
                'height',
                'overflow',
                'transition-duration',
                'transition-property'
            ].forEach(function(prop) {
                return target.style.removeProperty(prop);
            });
            resolve();
        }, duration);
    });
};
var $9578f243206a91ae$export$715de50cedc228a8 = function(target) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    return window.getComputedStyle(target).display === 'none' ? $9578f243206a91ae$export$abdd11a06a163232(target, duration) : $9578f243206a91ae$export$deed561b1a0ff1ea(target, duration);
};

});

parcelRegister("9vUSI", function(module, exports) {

$parcel$export(module.exports, "scrollToElement", function () { return $6ed321ce261ae421$export$2353115f31f4d15; });
var $6ed321ce261ae421$export$2353115f31f4d15 = function(selector) {
    var targetEl = document.querySelector(selector);
    if (!targetEl) return;
    window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top);
};

});

parcelRegister("5BaYK", function(module, exports) {

$parcel$export(module.exports, "waitForElement", function () { return $4138ec9fb36217c9$export$1a1c301579a08d1e; });
var $4138ec9fb36217c9$export$1a1c301579a08d1e = function(selector) {
    return new Promise(function(resolve) {
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        var observer = new MutationObserver(function() {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

});


parcelRegister("jlUaU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e16b8da7da809cdc$export$71511d61b312f219; });

var $dTQYG = parcelRequire("dTQYG");

var $d95Qy = parcelRequire("d95Qy");

var $eanwW = parcelRequire("eanwW");

var $J66Jb = parcelRequire("J66Jb");
function $e16b8da7da809cdc$export$71511d61b312f219(arr) {
    return (0, $dTQYG._)(arr) || (0, $d95Qy._)(arr) || (0, $J66Jb._)(arr) || (0, $eanwW._)();
}

});
parcelRegister("dTQYG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a1e981ac9d7864a0$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $a1e981ac9d7864a0$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2PuG4._)(arr);
}

});
parcelRegister("2PuG4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $20f8241f6119e7d1$export$71511d61b312f219; });
function $20f8241f6119e7d1$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("d95Qy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9920a6ac5bee97c9$export$71511d61b312f219; });
function $9920a6ac5bee97c9$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eanwW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a504407b7f865a13$export$71511d61b312f219; });
function $a504407b7f865a13$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("J66Jb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0878f0e8b254b036$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $0878f0e8b254b036$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2PuG4._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2PuG4._)(o, minLen);
}

});


parcelRequire("6VBea");
var $2pyvk = parcelRequire("2pyvk");
var $09c62362636671de$export$1ad1318d6327f8a6 = {
    content: 'main',
    excludedHeadlines: 'div.toc-exclude :is(h2, h3, h4, h5, h6)',
    tableOfContents: '.toc',
    tocMobile: '.toc--mobile'
};
var $09c62362636671de$export$b05c0648ff4c0a50 = 'toc-';
var $09c62362636671de$export$1b53d3b208e4acbd = 'toc--mobile';


var $f02fc496e25e9471$var$HEADING_SELECTOR = 'h2, h3, h4, h5, h6';
var $f02fc496e25e9471$var$DEFAULT_MAX_DEPTH = 5;
var $f02fc496e25e9471$var$getHeadingLevel = function(heading) {
    return Number.parseInt(heading.tagName.slice(1), 10);
};
var $f02fc496e25e9471$var$getHeadingText = function(heading) {
    return heading.textContent.trim();
};
var $f02fc496e25e9471$var$ensureHeadingAnchor = function(heading, fallbackIndex, usedAnchors) {
    var anchor = heading.id || "".concat((0, $09c62362636671de$export$b05c0648ff4c0a50)).concat(fallbackIndex);
    if (usedAnchors.has(anchor)) {
        var suffix = 1;
        var candidate = "".concat(anchor, "-").concat(suffix);
        while(usedAnchors.has(candidate)){
            suffix += 1;
            candidate = "".concat(anchor, "-").concat(suffix);
        }
        anchor = candidate;
    }
    heading.id = anchor;
    usedAnchors.add(anchor);
    return anchor;
};
var $f02fc496e25e9471$export$2509c156d7736017 = function(tocElement) {
    var depthAttribute = Number.parseInt(tocElement.getAttribute('data-depth'), 10);
    return Number.isNaN(depthAttribute) ? $f02fc496e25e9471$var$DEFAULT_MAX_DEPTH : Math.max(depthAttribute - 1, 0);
};
var $f02fc496e25e9471$export$1f8cfe0e97a860ac = function(headlineIndex) {
    if (!headlineIndex) {
        console.warn('Table of Contents: Content element not found');
        return [];
    }
    var allHeadlines = headlineIndex.querySelectorAll($f02fc496e25e9471$var$HEADING_SELECTOR);
    var excludedHeadlines = headlineIndex.querySelectorAll((0, $09c62362636671de$export$1ad1318d6327f8a6).excludedHeadlines);
    var excludedSet = new Set(excludedHeadlines);
    return Array.from(allHeadlines).filter(function(headline) {
        var isVisible = typeof headline.checkVisibility === 'function' ? headline.checkVisibility() : true;
        return !excludedSet.has(headline) && isVisible;
    });
};
var $f02fc496e25e9471$export$262bc79cb0130d72 = function(headlines) {
    var usedAnchors = new Set();
    return headlines.map(function(heading, index) {
        var level = $f02fc496e25e9471$var$getHeadingLevel(heading);
        var text = $f02fc496e25e9471$var$getHeadingText(heading);
        var anchor = $f02fc496e25e9471$var$ensureHeadingAnchor(heading, index, usedAnchors);
        return {
            anchor: anchor,
            heading: heading,
            level: level,
            text: text
        };
    });
};
// depth=N means H2 through H(N+1): base is always H2, not the minimum heading found.
var $f02fc496e25e9471$var$BASE_HEADING_LEVEL = 2;
var $f02fc496e25e9471$export$23bb7f59508a96e5 = function(headlines, maxDepth) {
    return headlines.filter(function(heading) {
        var depth = heading.level - $f02fc496e25e9471$var$BASE_HEADING_LEVEL;
        return depth <= maxDepth;
    });
};



var $f7b64d039793519d$var$ACTIVE_CLASS = 'is-active';
var $f7b64d039793519d$var$SCROLL_ACTIVATION_OFFSET = 120;
var $f7b64d039793519d$var$OBSERVER_BOTTOM_MARGIN = '70%';
var $f7b64d039793519d$var$tocCleanupHandlers = new WeakMap();
var $f7b64d039793519d$var$handleMobileSelectChange = function(event) {
    var targetSelector = event.target.value;
    var targetElement = targetSelector ? document.querySelector(targetSelector) : null;
    if (!targetElement) return;
    targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
};
var $f7b64d039793519d$var$updateActiveLink = function(tocLinks, nextActiveId) {
    if (!nextActiveId) return;
    tocLinks.forEach(function(link, anchorId) {
        link.classList.toggle($f7b64d039793519d$var$ACTIVE_CLASS, anchorId === nextActiveId);
    });
};
var $f7b64d039793519d$export$42e2c38005751b8 = function(tocElement) {
    var cleanup = $f7b64d039793519d$var$tocCleanupHandlers.get(tocElement);
    if (cleanup) {
        cleanup();
        $f7b64d039793519d$var$tocCleanupHandlers.delete(tocElement);
    }
};
var $f7b64d039793519d$export$64f7f3e2f6fe213e = function() {
    document.querySelectorAll("".concat((0, $09c62362636671de$export$1ad1318d6327f8a6).tocMobile, " select")).forEach(function(select) {
        select.onchange = $f7b64d039793519d$var$handleMobileSelectChange;
    });
};
var $f7b64d039793519d$export$fbf47666ff0bd03e = function(toc) {
    var isMobile = toc.classList.contains((0, $09c62362636671de$export$1b53d3b208e4acbd));
    if (isMobile) return;
    var tocLinks = new Map();
    toc.querySelectorAll('a[href^="#"]').forEach(function(link) {
        var href = link.getAttribute('href');
        if (!href || href.length < 2) return;
        var targetId = href.slice(1);
        tocLinks.set(targetId, link);
    });
    var anchors = Array.from(tocLinks.keys()).map(function(anchorId) {
        return document.getElementById(anchorId);
    }).filter(Boolean);
    if (anchors.length === 0) return;
    if (typeof window.IntersectionObserver !== 'function') return;
    var anchorOrder = new Map(anchors.map(function(anchor, index) {
        return [
            anchor.id,
            index
        ];
    }));
    var visibleAnchors = new Set();
    var currentActiveId = anchors[0].id;
    var getFirstVisibleAnchorId = function() {
        if (visibleAnchors.size === 0) return currentActiveId;
        var nextActiveId = null;
        var minIndex = Number.POSITIVE_INFINITY;
        visibleAnchors.forEach(function(anchorId) {
            var index = anchorOrder.get(anchorId);
            if (index < minIndex) {
                minIndex = index;
                nextActiveId = anchorId;
            }
        });
        return nextActiveId || currentActiveId;
    };
    var syncActiveLink = function(nextActiveId) {
        if (!nextActiveId) return;
        currentActiveId = nextActiveId;
        $f7b64d039793519d$var$updateActiveLink(tocLinks, nextActiveId);
    };
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var anchorId = entry.target.id;
            if (!anchorId) return;
            if (entry.isIntersecting) visibleAnchors.add(anchorId);
            else visibleAnchors.delete(anchorId);
        });
        syncActiveLink(getFirstVisibleAnchorId());
    }, {
        root: null,
        rootMargin: "-".concat($f7b64d039793519d$var$SCROLL_ACTIVATION_OFFSET, "px 0px -").concat($f7b64d039793519d$var$OBSERVER_BOTTOM_MARGIN, " 0px"),
        threshold: 0
    });
    anchors.forEach(function(anchor) {
        return observer.observe(anchor);
    });
    var scheduleUpdate = function() {
        syncActiveLink(getFirstVisibleAnchorId());
    };
    var handleTocClick = function(event) {
        var link = event.target.closest('a[href^="#"]');
        if (!link) return;
        var targetId = link.getAttribute('href').slice(1);
        if (targetId) syncActiveLink(targetId);
        window.requestAnimationFrame(scheduleUpdate);
    };
    window.addEventListener('resize', scheduleUpdate);
    toc.addEventListener('click', handleTocClick);
    syncActiveLink(anchors[0].id);
    $f7b64d039793519d$var$tocCleanupHandlers.set(toc, function() {
        window.removeEventListener('resize', scheduleUpdate);
        toc.removeEventListener('click', handleTocClick);
        observer.disconnect();
        visibleAnchors.clear();
    });
};




var $jlUaU = parcelRequire("jlUaU");
var $001dcb916b5b9f07$export$2272fe7bc7c7d5a4 = function(tocElement, isMobile) {
    if (isMobile) {
        var selectElement = tocElement.querySelector('select');
        if (selectElement) selectElement.innerHTML = '';
        return;
    }
    tocElement.innerHTML = '';
};
var $001dcb916b5b9f07$export$46313927d6d8983d = function(filteredHeadlines, tocElement) {
    var _Math;
    var minLevel = (_Math = Math).min.apply(_Math, (0, $jlUaU._)(filteredHeadlines.map(function(heading) {
        return heading.level;
    })));
    var toc = '';
    var previousLevel = 0;
    filteredHeadlines.forEach(function(heading) {
        var headingLevel = heading.level, headerText = heading.text, anchor = heading.anchor;
        var depth = headingLevel - minLevel + 1;
        if (previousLevel === 0) toc += '<ul class="lvl-'.concat(depth, '"><li><a class="no-link" href="#').concat(anchor, '">').concat(headerText, "</a>");
        else if (headingLevel > previousLevel) {
            var levelDiff = headingLevel - previousLevel;
            for(var j = 0; j < levelDiff; j++)toc += '<ul class="lvl-'.concat(depth - levelDiff + j + 1, '">');
            toc += '<li><a class="no-link" href="#'.concat(anchor, '">').concat(headerText, "</a>");
        } else if (headingLevel < previousLevel) {
            var levelDiff1 = previousLevel - headingLevel;
            toc += '</li>';
            for(var j1 = 0; j1 < levelDiff1; j1++)toc += '</ul></li>';
            toc += '<li><a class="no-link" href="#'.concat(anchor, '">').concat(headerText, "</a>");
        } else toc += '</li><li><a class="no-link" href="#'.concat(anchor, '">').concat(headerText, "</a>");
        previousLevel = headingLevel;
    });
    if (previousLevel > 0) {
        var _Math1;
        toc += '</li>';
        var minListLevel = (_Math1 = Math).min.apply(_Math1, (0, $jlUaU._)(filteredHeadlines.map(function(heading) {
            return heading.level;
        })));
        var remainingLevels = previousLevel - minListLevel;
        for(var j = 0; j < remainingLevels; j++)toc += '</ul></li>';
        toc += '</ul>';
    }
    tocElement.innerHTML = toc;
};
var $001dcb916b5b9f07$export$1f9cd6f2603c0bab = function(filteredHeadlines, tocElement) {
    var toc = '';
    filteredHeadlines.forEach(function(heading) {
        var headerText = heading.text, anchor = heading.anchor;
        toc += '<option value="#'.concat(anchor, '">').concat(headerText, "</option>");
    });
    var selectElement = tocElement.querySelector('select');
    if (selectElement) selectElement.innerHTML = toc;
};


var $da42913864e333db$var$buildToc = function(headlineIndex, tocElement) {
    (0, $f7b64d039793519d$export$42e2c38005751b8)(tocElement);
    var isMobile = tocElement.classList.contains((0, $09c62362636671de$export$1b53d3b208e4acbd));
    var maxDepth = (0, $f02fc496e25e9471$export$2509c156d7736017)(tocElement);
    var headlines = (0, $f02fc496e25e9471$export$1f8cfe0e97a860ac)(headlineIndex);
    if (headlines.length === 0) {
        (0, $001dcb916b5b9f07$export$2272fe7bc7c7d5a4)(tocElement, isMobile);
        return;
    }
    var headingData = (0, $f02fc496e25e9471$export$262bc79cb0130d72)(headlines);
    var filteredHeadlines = (0, $f02fc496e25e9471$export$23bb7f59508a96e5)(headingData, maxDepth);
    if (filteredHeadlines.length === 0) {
        (0, $001dcb916b5b9f07$export$2272fe7bc7c7d5a4)(tocElement, isMobile);
        return;
    }
    if (isMobile) (0, $001dcb916b5b9f07$export$1f9cd6f2603c0bab)(filteredHeadlines, tocElement);
    else (0, $001dcb916b5b9f07$export$46313927d6d8983d)(filteredHeadlines, tocElement);
    (0, $f7b64d039793519d$export$64f7f3e2f6fe213e)();
    (0, $f7b64d039793519d$export$fbf47666ff0bd03e)(tocElement);
};
var $da42913864e333db$export$ad7f1972714f6221 = function(toc) {
    if (!toc) {
        console.warn('Table of Contents: TOC element not found');
        return;
    }
    var contentElement = document.querySelector((0, $09c62362636671de$export$1ad1318d6327f8a6).content);
    if (!contentElement) console.warn('Table of Contents: Content element not found. Using document body as fallback.');
    var headlineIndex = contentElement || document.body;
    $da42913864e333db$var$buildToc(headlineIndex, toc);
};



var $dcd2fc4910b8edd3$var$runInitialization = function() {
    document.querySelectorAll((0, $09c62362636671de$export$1ad1318d6327f8a6).tableOfContents).forEach((0, $da42913864e333db$export$ad7f1972714f6221));
};
$dcd2fc4910b8edd3$var$runInitialization();
(0, $2pyvk.addWindowResizeEvent)($dcd2fc4910b8edd3$var$runInitialization);

})();
//# sourceMappingURL=table_of_contents.min.js.map
